<div class="row">
  <div class="col-12">
    <label for="disp-clientname">Client Name</label>
    <span class="actualdata">{{ studyVM.study.clientName }}</span>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <label for="disp-studyname">Study Name</label>
    <span class="actualdata">{{ studyVM.study.studyName }}</span>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <label for="disp-studySummary">Study Summary</label>
    <span class="actualdata">{{ studyVM.study.studySummary }}</span>
  </div>
</div>

<div class="row">
  <div class="col-6">
    <label for="disp-offcCountry">Project Office Country</label>
    <span class="actualdata">{{ studyVM.OfficeCountryNameText }}</span>
  </div>
  <div class="col-6">
    <label for="disp-offcCity">Project Office City</label>
    <span class="actualdata">{{ studyVM.OfficeCityNameText }}</span>
  </div>
</div>

<div class="row">
  <div class="col-6">
    <label for="disp-sd">Start Date</label>
    <span class="actualdata">{{ studyVM.study.displayStartDate | date: 'dd-MMM-yyyy' }}</span>
  </div>
  <div class="col-6">
    <label for="disp-ed">End Date</label>
    <span class="actualdata">{{ studyVM.study.displayEndDate | date: 'dd-MMM-yyyy' }}</span>
  </div>
</div>

<div class="row">
  <div class="col-6">
    <label for="disp-fy">Fiscal Year</label>
    <span class="actualdata">{{ studyVM.FiscalYearText }}</span>
  </div>
  <div class="col-6 icon-inline">
    <div *ngIf="studyVM.study.isStudyConfidential">
      <label>
        <i class="material-icons"> check </i>
      </label>
      <span class="actualdata">Set study to <strong>confidential</strong></span>
    </div>
    <div class="study-rd-btn ms-1">
      <div class="usrDefined">
        <label class="form-check-label">Mark as <strong>Demo/Test</strong> Study:</label>
        &nbsp; &nbsp;
        <div class="custom-control custom-radio custom-control-inline">
          <input
            type="radio"
            id="markDemoStudyYesReadonly"
            name="markDemoStudyYesReadonly"
            [value]="true"
            class="custom-control-input"
            [(ngModel)]="studyVM.study.isDemoStudy"
            [disabled]="true"
          />
          <label class="custom-control-label form-check-label" for="markTestStudyYes">Yes</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input
            type="radio"
            id="markDemoStudyNoReadonly"
            name="markDemoStudyNoReadonly"
            [value]="false"
            class="custom-control-input"
            [(ngModel)]="studyVM.study.isDemoStudy"
            [disabled]="true"
          />
          <label class="custom-control-label form-check-label" for="markDemoStudyNo">No</label>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-6">
    <label for="disp-studyEngagementId">Engagement Id</label>
    <span class="actualdata">{{ studyVM.study.engagementId }}</span>
  </div>
  <div class="col-6">
    <label for="disp-studyClientChannelName">Client Channel Name</label>
    <span class="actualdata">{{ studyVM.study.engagementClientChannelName }}</span>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <label for="region-country">World regions (geographical)</label>
    <p-tree [value]="displayBenchmarkRegionCountry"></p-tree>
  </div>
</div>
<hr />
<div class="title">Period of Study</div>
<div class="row">
  <div class="col-6">
    <label for="disp-pb">Period Beginning</label>
    <span class="actualdata">{{ studyVM.study.periodOfStudyFrom }}</span>
  </div>
  <div class="col-6">
    <label for="disp-pe">Period Ending</label>
    <span class="actualdata">{{ studyVM.study.periodOfStudyTo }}</span>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="study-rd-btn ms-1">
      <div class="custom-control custom-radio custom-control-inline">
        <input
          type="radio"
          id="mar31alignment"
          name="mar31alignment"
          [value]="fyAlignmentMethod.March31"
          class="custom-control-input"
          [(ngModel)]="studyVM.study.fyAlignmentMethodID"
          [disabled]="true"
        />
        <label class="custom-control-label form-check-label" for="mar31alignment">Mar 31<sup>st</sup> FY Alignment</label>
      </div>

      <div class="custom-control custom-radio custom-control-inline">
        <input
          type="radio"
          id="5_7alignment"
          name="5_7alignment"
          [value]="fyAlignmentMethod.Previous7Month"
          class="custom-control-input"
          [(ngModel)]="studyVM.study.fyAlignmentMethodID"
          [disabled]="true"
        />
        <label class="custom-control-label form-check-label" for="5_7alignment">5/7 FY Alignment</label>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="studyVM.study.fyAlignmentMethodID === fyAlignmentMethod.Previous7Month">
  <div class="col-6">
    <label for="disp-pb">Tested Party Fiscal Year End</label>
    <span class="actualdata">{{ studyVM.study.displaytestedPartyFiscalYearEnd | date: 'dd-MMM-yyyy' }}</span>
  </div>
  <div class="col-6">
    <label for="disp-pe">Months Back</label>
    <span class="actualdata">{{ studyVM.study.monthsBack }}</span>
  </div>
</div>
<hr />
<div class="title">Currency Information</div>

<div class="row">
  <div class="col-12" style="font-size: 14px">Reference Currency</div>
  <div class="col-6">
    <label for="disp-src">Study Reference Currency</label>
    <span class="actualdata">{{ studyVM.StudyReferenceCurrencyText }}</span>
  </div>
  <div class="col-6">
    <label for="disp-scu">Study Currency Units</label>
    <span class="actualdata">{{ studyVM.StudyCurrencyUnitsText }}</span>
  </div>
  <div class="col-12 icon-inline" *ngIf="studyVM.study.useFunctionalCurrency">
    <label>
      <i class="material-icons"> check </i>
    </label>
    <span class="actualdata">Use Functional Currency for Reports</span>
    <p class="functionalCurrText">Check the Functional currency box to generate Reports in Functional Currency</p>
  </div>
</div>

<hr />
<h5>PLI Settings</h5>
<div id="dvFinancialResultsFormatting">
  <div class="row">
    <div class="col-12">
      <div>
        Selected PLIs
        <div>
          <ng-container *ngFor="let ratio of studyVM.ratios; index as i">
            <ng-template #ratioTooltipContent
              ><div class="tooltip-ratio">{{ 'ratio_' + ratio.acronym | tpbTooltip }}</div></ng-template
            >
            <div class="usrDefined">
              <div class="custom-control custom-control-inline">
                <p-checkbox
                  id="ratio_{{ i + 1 }}"
                  name="ratio_{{ i + 1 }}"
                  [value]="ratio.ratioId"
                  [(ngModel)]="studyVM.selectedRatios"
                  [disabled]="true"
                ></p-checkbox>
                <!--<input type="checkbox" id="rFormat_{{i+1}}" name="resultformat_{{i+1}}" [value]="ratio.ratioId" class="custom-control-input" [(ngModel)]="studyVM.study.financialResultFormatId" required
                #resultformat [disabled]="leveragedStudy">-->
                <label style="margin-top: 7.1px" class="form-check-label" [ngbTooltip]="ratioTooltipContent" for="ratio_{{ i + 1 }}">{{
                  ratio.name
                }}</label>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <h5>Default Base for PLI Calculation</h5>
  <div *ngIf="true" class="row">
    <div class="col-12">
      <div [ngClass]="">
        <div class="study-rd-btn ms-1">
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              class="custom-control-input"
              id="PLICalcBaseOpr"
              name="PLICalcBaseOpr"
              [value]="basePLIVendorAccount.OperatingRevenue"
              [(ngModel)]="studyVM.study.defaultBasePLIVendorAccountId"
              [disabled]="true"
            />
            <label class="custom-control-label form-check-label" for="PLICalcBaseOpr">Operating Revenue</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              class="custom-control-input"
              id="PLICalcBaseNetSales"
              name="PLICalcBaseNetSales"
              [value]="basePLIVendorAccount.NetSales"
              [(ngModel)]="studyVM.study.defaultBasePLIVendorAccountId"
              [disabled]="true"
            />
            <label class="custom-control-label form-check-label" for="PLICalcBaseNetSales">Net Sales</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      Default Average Method
      <div class="study-rd-btn ms-1" style="width: 100%; display: flex">
        <div>
          <ng-container *ngFor="let averagingMethod of studyVM.defaultAveragingMethods; index as i">
            <div style="display: inline-block">
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  id="averagingMethod_{{ i + 1 }}"
                  name="averagingMethod_{{ i + 1 }}"
                  [value]="averagingMethod.lookupId"
                  class="custom-control-input"
                  [(ngModel)]="studyVM.study.averagingMethodID"
                  [disabled]="true"
                />
                <label class="custom-control-label form-check-label" for="averagingMethod_{{ i + 1 }}">{{ averagingMethod.displayText }}</label>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      Default Interquartile Calculation Method
      <div class="study-rd-btn ms-1" style="width: 100%; display: flex">
        <ng-container *ngFor="let rFormat of studyVM.financialResultsFormatting; index as i">
          <div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                id="rFormat_{{ i + 1 }}"
                name="resultformat_{{ i + 1 }}"
                [value]="rFormat.lookupId"
                class="custom-control-input"
                [(ngModel)]="studyVM.study.financialResultFormatId"
                [disabled]="true"
              />
              <label class="custom-control-label form-check-label" for="rFormat_{{ i + 1 }}">{{ rFormat.displayText }}</label>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<hr />
<div class="title">Study Settings</div>
<div class="row">
  <div class="col-12">
    <div class="study-rd-btn ms-1">
      <ng-container *ngFor="let setting of studyVM.studySettings; index as i">
        <div class="custom-control custom-radio custom-control-inline">
          <input
            type="radio"
            id="setting_{{ i + 1 }}"
            [value]="setting.lookupId"
            class="custom-control-input"
            [(ngModel)]="studyVM.study.studySettingId"
            [disabled]="true"
          />
          <label class="custom-control-label form-check-label" for="setting_{{ i + 1 }}">{{ setting.displayText }}</label>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="form-group">
      <p-checkbox
        id="translateNLChk"
        name="translateNLChk"
        [(ngModel)]="studyVM.study.translateNativeLanguageTD"
        binary="true"
        disabled
        selected
      ></p-checkbox>
      <label class="form-check-label" for="functionalCurrency">Translate Native Language Trade Description</label>
      <p class="functionalCurrText">Check Native Language TD box to get it translated for all companies that pass Search Strategy</p>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <span for="isAISuggestionsEnabled">Enable AI assisted suggestions on the BDR Grid</span>
    <div class="row" class="switch-container-study-setup-readonly">
      <div class="custom-control custom-control-inline">
        <label class="ai-enabled custom-control-label form-check-label" placement="top">No</label>
        <p-inputSwitch name="isAISuggestionsEnabled" [(ngModel)]="studyVM.study.isAISuggestionsEnabled" [disabled]="true"></p-inputSwitch>
        <label class="ai-disabled custom-control-label form-check-label">Yes</label>
      </div>
    </div>
  </div>
</div>
<div class="title">Display Settings</div>
<div class="row">
  <div class="col-12">
    <div class="study-rd-btn ms-1">
      <label class="me-3">Number of companies displayed per page:</label>
      &nbsp;
      <ng-container *ngFor="let option of studyVM.itemsPerPageOptions; index as i">
        <div class="custom-control custom-radio custom-control-inline">
          <input
            type="radio"
            id="displaySetting_{{ i + 1 }}"
            [value]="option"
            class="custom-control-input"
            [(ngModel)]="studyVM.study.itemsPerPage"
            [disabled]="true"
          />
          <label class="custom-control-label form-check-label" for="displaySetting_{{ i + 1 }}">{{ option }}</label>
        </div>
      </ng-container>
    </div>
  </div>
</div>
